import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
   state: {
      navState:0
   },
   getters: {
      
   },
   mutations: {
      getState(state, data) {
         state.navState = data.index
      },
   },
   actions: {

   },
   modules: {

   }
})
